import commonMixins from "./common";
import * as R from "ramda";
import { MODE, MODE_CHILD_STYLE } from "./constant";
const {
    renderer,
    store: { variable },
} = require('@futuweb/fego-render');;
const {
    state: { initCmpStateMatchine },
} = require('@futuweb/fego-bridge');;
import { rendererCreator } from './children';


function fatory(ops = { mode: MODE.FREE }) {
    return {
        extends: commonMixins,
        components: {
            renderer: renderer,
            ChildrenRenderer: rendererCreator(renderer, ops)
        },
        computed: {
            statedChildren() {
                return this.tpl.children.map((tpl, i) => {
                    return R.mergeDeepRight(
                        tpl,
                        initCmpStateMatchine(tpl, variable.data)
                    );
                });
            },
        },
        methods: {
            setStyle(e) {
                let style = commonMixins.methods.setStyle.call(this, e);
                return Object.assign(style, MODE_CHILD_STYLE[ops.mode] || {});
            }
        }
    };
}
export default fatory;



// WEBPACK FOOTER //
// ./src/sdk/container/render-mixin.js